
import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { Dialog, DialogContent, DialogActions, Button, Typography, Grid } from '@mui/material';

import { RootState } from '../store';
import { setReducerTurno } from '../store/slices/TurnoSlice';

import { BoxTurnos } from '../components/BoxTurnos';

import { DialogContentStyle, DialogActionsStyle } from '../styles/DialogStyle';

import { CancelarTurno, ConcluirTurno, IniciarAtencion, TomarTurno } from '../connections/comun/TurnosConnection';

import { defaultTurno } from '../interfaces/turnos/TurnoInterface';

interface Props {
    openDialog:              boolean;
    handleCloseDialog:       () => void;
}

export interface Errors {
    descripcion?:  string;
}

export const DialogTurno = ( { openDialog, handleCloseDialog }: Props ) => {  
    
    const dispatch = useDispatch();

    const { turno } = useSelector( ( state: RootState ) => state.turno );

    const [loading, setLoading] = useState( false );
    const [loadingCancelar, setLoadingCancelar] = useState( false );
    const [loadingConcluir, setLoadingConcluir] = useState( false );
    const [loadingIniciarAtencion, setLoadingIniciarAtencion] = useState( false );

    const [errors, setErrors] = useState<Errors>( {} );

    const handleClose = () => {
        setErrors( {} );
        handleCloseDialog();
    }

    const handleCancelarTurno = async () => {

        setErrors( {} );
        setLoadingCancelar( true );

        await CancelarTurno({ idTurno: turno.turno_id, idTurnoEstado: 4, numeroCubiculo: 0 }).then( resp => {
     
            const { success, message } = resp;

            if( success ){              

                setTimeout(() => {
    
                    dispatch( setReducerTurno( { turno: defaultTurno, loadingTurno: false, } ) );
                    setLoadingCancelar( false );

                }, 700);              

            }
            else {

                setTimeout(() => {                         
                    
                    setErrors({ descripcion: message });
                    setLoadingCancelar( false );    

                }, 500);

            }

        });  

    }    
    
    const handleIniciarAtencion = async () => {

        setErrors( {} );
        setLoadingIniciarAtencion( true );

        await IniciarAtencion({ idTurno: turno.turno_id, idTurnoEstado: 2, numeroCubiculo: 0 }).then( resp => {
     
            const { success, message, data } = resp;

            if( success ){              

                setTimeout(() => {
    
                    dispatch( setReducerTurno( { turno: data, loadingTurno: false, } ) );
                    setLoadingIniciarAtencion( false );

                }, 700);              

            }
            else {

                setTimeout(() => {                         
                    
                    setErrors({ descripcion: message });
                    setLoadingIniciarAtencion( false );    

                }, 500);

            }

        });  

    }
    
    const handleConcluirTurno = async () => {

        setErrors( {} );
        setLoadingConcluir( true );

        await ConcluirTurno({ idTurno: turno.turno_id, idTurnoEstado: 3, numeroCubiculo: 0 }).then( resp => {
     
            const { success, message } = resp;

            if( success ){              

                setTimeout(() => {
    
                    dispatch( setReducerTurno( { turno: defaultTurno, loadingTurno: false, } ) );
                    setLoadingConcluir( false );
                    handleCloseDialog();

                }, 700);              

            }
            else {

                setTimeout(() => {                         
                    
                    setErrors({ descripcion: message });
                    setLoadingConcluir( false );    

                }, 500);

            }

        });  

    }

    const handleGenerarTurno = async () => {

        setErrors( {} );
        setLoading( true );

        await TomarTurno().then( resp => {
     
            const { success, message, data } = resp;

            if( success ){

                if( data ){        

                    setTimeout(() => {              

                        setTimeout(() => {
            
                            dispatch( setReducerTurno( { turno: data, loadingTurno: false, } ) );
                            setLoading( false );

                        }, 700);

                    }, 500);
                }

            }
            else {

                setTimeout(() => {                         
                    
                    setErrors({ descripcion: message });
                    setLoading( false );    

                }, 500);

            }

        });  

    }
    
    return (
        <>
            <Dialog 
                fullWidth
                maxWidth='sm' 
                open={ openDialog }   
            >
           
                <DialogContent sx={{ ...DialogContentStyle, height: 380 }}>
             
                    <Grid container spacing={3}>

                        <Grid size={{ md: 12, xs: 12 }} textAlign={'center'} mt={1}>
                            <Button                                
                                variant='contained'
                                disabled={ turno.turno_numero !== 0 }
                                loading={ loading }
                                onClick={ handleGenerarTurno }
                            >
                                Tomar turno
                            </Button>
                        </Grid>
                        
                        {
                            errors.descripcion
                            ?
                                <BoxTurnos message={ errors.descripcion } />
                            :
                                <Grid textAlign={'center'} size={{ md: 12, xs: 12 }}>
                                    {
                                        turno.turno_numero !== 0
                                        &&
                                            <Typography variant='h1' fontSize={220}>
                                                { turno.turno_numero }
                                            </Typography>
                                    }
                                </Grid>
                        }

                    </Grid>
                    
                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    {
                        ( turno.turno_numero === 0 || turno.turno_estado.id !== 7 )
                        &&
                            <Button fullWidth={ turno.turno_numero !== 0 } color="secondary" onClick={ handleClose } >
                                Cerrar
                            </Button>       
                    }
                    
                    {
                        turno.turno_numero !== 0 
                        &&
                            <Button 
                                fullWidth
                                color="warning" 
                                variant='contained' 
                                loading={ loadingCancelar }
                                onClick={ handleCancelarTurno } 
                            >
                                Cancelar turno
                            </Button>
                    } 

                    {
                        ( turno.turno_numero !== 0 && turno.turno_estado.id === 7 )
                        &&
                            <Button      
                                fullWidth                           
                                color="primary" 
                                variant='contained' 
                                loading={ loadingIniciarAtencion }
                                onClick={ handleIniciarAtencion } 
                            >
                                Iniciar atención
                            </Button>
                    } 

                    {
                        ( turno.turno_numero !== 0 && turno.turno_estado.id === 2 )
                        &&
                            <Button 
                                fullWidth
                                color="success" 
                                variant='contained' 
                                loading={ loadingConcluir }
                                onClick={ handleConcluirTurno } 
                            >
                                Concluir turno
                            </Button>
                    } 

                </DialogActions>

            </Dialog>
        </>
    )
}